import { Box, Center, Container, Heading, VStack } from '@chakra-ui/react';
import React from 'react';
import { Authenticated } from './AuthGuards';
import { Fade } from './Fade';
import { NotificationSettings } from './NotificationSettings';
import { PageHeader } from './PageHeader';
import { PasswordResetForm } from './PasswordResetForm';

export const AccountSettings = () => (
  <Authenticated>
    <Fade>
      <Container w={['xs', 'md', 'lg']}>
        <Center>
          <VStack spacing={8} align="flex-start">
            <PageHeader
              title="Account Settings"
              subtitle="Here you can manage all aspects of your account"
              emoji={{ symbol: '⚙️', label: 'emoji of a cog' }}
            />
            <Box w="full">
              <Heading size="md" pb={4}>
                Change Password
              </Heading>
              <PasswordResetForm />
            </Box>
            <Box w="full" pb={8}>
              <NotificationSettings />
            </Box>
          </VStack>
        </Center>
      </Container>
    </Fade>
  </Authenticated>
);
